import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/logo.svg';
import './footer.css';

function Footer() {
  const { t } = useTranslation('global');

  return (
    <footer className="site-footer">
      <div className="bm-container site-footer__grid">
        <div className="site-footer__brand">
          <Link to="/">
            <img src={logo} alt="BeoMedica" width="180" height="79" />
          </Link>
        </div>

        <div className="site-footer__col">
          <h4>{t('navbar.home')}</h4>
          <ul>
            <li>
              <a href="/#about">{t('navbar.about')}</a>
            </li>
            <li>
              <a href="/#our_partners">{t('navbar.our_partners')}</a>
            </li>
            <li>
              <Link to="/vesti">{t('navbar.news')}</Link>
            </li>
            <li>
              <a href="/#contact">{t('navbar.contact')}</a>
            </li>
          </ul>
        </div>

        <div className="site-footer__col">
          <h4>{t('navbar.products')}</h4>
          <ul>
            <li>
              <Link to="/idroflog">Idroflog</Link>
            </li>
            <li>
              <Link to="/laluvit">Ialuvit</Link>
            </li>
            <li>
              <Link to="/oftaial-plus">Oftaial Plus</Link>
            </li>
          </ul>
        </div>

        <div className="site-footer__col">
          <h4>{t('contact.firma')}</h4>
          <ul>
            <li>{t('contact.address')}</li>
            <li>
              <a href="tel:+381114508418">{t('contact.phone')}</a>
            </li>
            <li>
              <a href={`mailto:${t('contact.email')}`}>{t('contact.email')}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="bm-container">
          <p className="site-footer__copyright">
            Copyright &copy; Beomedica, Powered by{' '}
            <a
              href="https://malkier.rs"
              target="_blank"
              rel="noopener noreferrer"
            >
              Malkier
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
